if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"sbg_evo","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1([27]29|057|614)|2(013|103|274|777|805|91)|3(63[13]|277|315)|4(133|217|547|82|89)|5(2(61|7|99)|73[57]|051|443|599|903)|6(018|146|255|747|909)|7(81(|5)|191|20|389|485|539|582|971)|8(019|198|203|474|707|735)|9291|9553)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}